let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("VBVa9")).then(() => parcelRequire('ldK5O'));